import { Flex, Typography } from '@banhala/ui-kit';
import { useMemo, useState } from 'react';

export const useClickMore = () => {
  const [isClickedMore, setIsClickedMore] = useState(false);

  const MoreButton = useMemo(() => {
    if (isClickedMore) return null;

    return (
      <Flex
        onPress={() => setIsClickedMore(true)}
        padding={{ top: 32, left: 4 }}
      >
        <Typography type="subtitle2" color="content_positive">
          필터 더보기
        </Typography>
      </Flex>
    );
  }, [isClickedMore]);

  return {
    isClickedMore,
    MoreButton,
  };
};
